



























import mixins from 'vue-typed-mixins'
import linkAdsListMixin from '@/components/Mixins/linkAdsList'
import { GiftItem } from '@/api/handler'

export default mixins(linkAdsListMixin<GiftItem>()).extend({
  props: {
    pfStructure: String,
    isBtnDisabled: Boolean
  },

  mounted() {
    this.mountedReport()
  }
})
